import { Expensable } from 'modules/expenses/types/Expensable'

interface Props {
  expensable?: Expensable
}

export const useExpensableJournalEntries = ({ expensable }: Props) => {
  const expense = expensable?.expense

  if (!expense) return { journalDraftEntry: null, journalEntries: [] }

  if (expense.documentType === 'invoice') {
    return {
      journalDraftEntry:
        expense.financialDocumentAssociation?.financialDocument?.journalDraftEntry || null,
      journalEntries: (
        expense.financialDocumentAssociation?.financialDocument?.journalEntries || []
      )
        .flatMap((entry) => (entry.reversalEntry ? [entry, entry.reversalEntry] : [entry]))
        .sort((a, b) => b.id.localeCompare(a.id, undefined, { numeric: true })),
    }
  } else {
    return {
      journalDraftEntry: expense.journalDraftEntry || null,
      journalEntries: (expense.journalEntries || [])
        .flatMap((entry) => (entry.reversalEntry ? [entry, entry.reversalEntry] : [entry]))
        .sort((a, b) => b.id.localeCompare(a.id, undefined, { numeric: true })),
    }
  }
}
